import FixedContainer from './fixed-container';
export default FixedContainer;
